export default __webpack_public_path__ + "static/media/023-w.a80b19ac.svg";